import { call, put, take, takeLatest } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { getErrorMessage } from 'utils/apiError';
import { PayloadAction } from '@reduxjs/toolkit';
import { TTransactionsRequestPayload, TTransactionsResponsePayload } from './types';
import { assetsInitState, getTransactionsRequest, getTransactionsSuccess } from './reducer';
import { refreshTokenByTimeOutRequest, refreshTokenByTimeOutSuccess } from '../auth/reducer';

function* getTransactionsWorker(action: PayloadAction<TTransactionsRequestPayload>) {
	const { payload } = action;
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TTransactionsResponsePayload = yield call(
			api.transactions.getTransactions,
			payload,
		);
		yield put(getTransactionsSuccess(response));
	} catch (error) {
		notificationContainer(getErrorMessage(error), 'error');
		yield put(assetsInitState());
	}
}

export function* transactionsSaga() {
	// only the last requested page is shown (fast paging, reload after a payment)
	yield takeLatest(getTransactionsRequest.type, getTransactionsWorker);
}
